import {
    Box,
    HStack,
    Progress,
    Text,
} from "@chakra-ui/react";

const PartnerMilestone = ({
    title,
    progress = 0,
    label,
}) => {
    return (
        <Box
            minW="170px"
        >
            <HStack
                justify="space-between"
                mb={1}
            >
                <Text
                    fontSize="xs"
                    color="#071D54"
                    fontWeight="600"
                >
                    {title}
                </Text>

                {label && (
                    <Text
                        fontSize="xs"
                        color="#2453FF"
                        fontWeight="700"
                    >
                        {label}
                    </Text>
                )}
            </HStack>

            <Progress.Root
                value={progress}
                size="sm"
                borderRadius="full"
            >
                <Progress.Track
                    bg="#E8EEFF"
                >
                    <Progress.Range
                        bg="#2453FF"
                    />
                </Progress.Track>
            </Progress.Root>
        </Box>
    );
};

export default PartnerMilestone;